import React, { useContext } from 'react'
import { NewContext } from '../../Context/NewContext';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { IoMdClose } from 'react-icons/io'
function FeedbackPreview() {
    const { openPreview, setopenPreview, formData } = useContext(NewContext);
    return (
        <div>
            <Dialog
                open={openPreview}
                onClose={() => setopenPreview(false)}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "840px",
                            borderRadius: "12px"
                        },
                    },
                }}
            >
                <div className='flex justify-between'>
                    <DialogTitle id="responsive-dialog-title" className='w-full p-0  text-[#1E1627] !text-[24px] font-medium leading-none '>
                        <div className="flex items-center justify-between">
                            {"Preview"}
                            <IoMdClose className='float-right cursor-pointer' onClick={() => setopenPreview(false)} />
                        </div>
                    </DialogTitle>
                </div>

                <DialogContent>
                    <div className=''>
                        <div className="flex gap-4">
                            {
                                formData?.feedbackImages?.map((item, i) => {
                                    return (
                                        <>
                                            <img src={item} alt="" key={i} className='w-[250px] rounded-lg' />
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default FeedbackPreview